import React, { Component } from 'react';
import './styles/RMSSelectDrug.css';
import './styles/RMSDosage.css';
import './styles/RMSProfile.css';
import backIcon from './images/backIcon.png';
import profileIcon from './images/profile.png';
import plusIcon from './images/plus.png';
import termsIcon from './images/terms.png';


class RMSProfile extends Component{

    constructor(props){
        super(props);

        const roles = [
            {
                id: 0,
                value: 'Caregiver'
            },
            {
                id: 1,
                value: 'Patient'
            },
            {
                id: 2,
                value: 'Healthcare Provider'
            }
        ];

        const experience = [
            {
                id: 0,
                value: 'Beginner'
            },
            {
                id: 1,
                value: 'Intermediate'
            },
            {
                id: 2,
                value: 'Expert'
            }
        ];

        this.state = {
            roles: roles,
            experience: experience
        }
    }

    compileFormData = (e) => {
      var formData = {};
      var fname = document.getElementById('profile_fname');
      var lname = document.getElementById('profile_lname');
      var role = document.getElementById('profile_role');
      var experience  = document.getElementById('profile_exp');
      var terms = document.getElementById('profile_terms');
      var subscribe = document.getElementById('profile_subscribe');

      if(fname){
          formData.fname = fname.value;
      }
      if(lname){
          formData.lname = lname.value;
      }
      if(role){
          for(let i=0; i < this.state.roles.length; i++){
              if(this.state.roles[i].id === parseInt(role.value, 10)){
                  formData.role = this.state.roles[i].value;
              }
          }
      }
      if(experience){
          for(let i=0; i < this.state.experience.length; i++){
              if(this.state.experience[i].id === parseInt(experience.value, 10)){
                  formData.experience = this.state.experience[i].value;
              }
          }
      }
      if(terms){
          formData.terms = terms.checked;
      }
      if(subscribe){
          formData.subscribe = subscribe.checked;
      }

      if(e){
          e.preventDefault();
      }

      this.props.updateUserData(formData);
      this.props.changePage('RMSSelectSyringeDriver');
    };

    render(){

        var dropDownItemsRoles = this.state.roles.map(item => {
           return (
             <option key={item.id} value={item.id}>{item.value}</option>
           );
        });

        var dropDownItemsExp = this.state.experience.map(item => {
           return (
             <option key={item.id} value={item.id}>{item.value}</option>
           );
        });

        return(
            <div className="row">
                <div className="col-lg-4 col-xs-12 drug-wrapper">
                    <div className="row">
                        <div className="col-lg-12 col-xs-12 drug-title">
                            <h4><img className="backbutton" src={backIcon} alt="Go Back" onClick={() => this.props.changePage('RMSSelectDrug')}/> Profile Information</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <form className="profile-form">
                                <div className="form-group">
                                    <img src={profileIcon} alt="profileIcon"/><input id="profile_fname" type="text" placeholder="First Name"/>
                                </div>
                                <div className="form-group">
                                    <input id="profile_lname" type="text" placeholder="Last Name"/>
                                </div>
                                <div className="form-group">
                                    <div>
                                        <img src={plusIcon} alt="plusIcon"/><label>Role: </label>
                                    </div>
                                    <div>
                                        <select id="profile_role">
                                            {dropDownItemsRoles}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <select id="profile_exp">
                                        {dropDownItemsExp}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <input type="checkbox" id="profile_terms"/>
                                    <label className="profile-form-chk-labels">I accept the <span className="profile-form-terms">Terms of Use</span></label>
                                    <img src={termsIcon} alt="termsIcon" className="profile-terms-icon"/>
                                </div>
                                <div className="form-group">
                                    <input type="checkbox" id="profile_subscribe"/>
                                    <label className="profile-form-chk-labels">Subscribe for emails</label>
                                </div>
                                <button className="profile-form-submit-btn" onClick={(event) => this.compileFormData(event)}>Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RMSProfile;


// WEBPACK FOOTER //
// ./src/RMSProfile.js